module.exports = __webpack_public_path__ + "static/img/case_detail_def.9cadff4a.png";